import { createContext, useState, useContext, useEffect } from "react";
import { API_ENDPOINTS } from "./api/config";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  const syncUser = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setUserData(null);
      setLoading(false);
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(API_ENDPOINTS.DASHPROFILE, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.ok) {
        const data = await res.json();
        // console.log("User data synced:", data);
        // Normalize data for both Employer and JobSeeker
        const isEmp = data.user.role === "employer";
        const name = isEmp ? data.profile.businessName : `${data.user.firstName} ${data.user.lastName}`;

        var initials = "--";
        if(isEmp && data.profile.businessName) {
          initials = data.profile.businessName.split(" ").map(w => w[0]).join("").substring(0, 2).toUpperCase();
        } else if(!isEmp && data.user.firstName && data.user.lastName) {
          initials = (data.user.firstName[0] + data.user.lastName[0]).toUpperCase();
        } else {
          initials = "--";
        }

        setUserData({
          ...data.user,
          ...data.profile,
          displayName: name,
          initials: initials,
          notifications: data.notificationsCount || 0,
          shortlistCount: data.shortlistCount || 0,
          listingsCount: data.listingsCount || 0,
          isAdmin: data.user.isAdmin || false,
        });
      }else {
        // If the token is invalid/expired (401/403), clear the user
        setUserData(null);
        localStorage.removeItem("token");
      }
    } catch (err) {
      console.error("Context Sync Error:", err);
      setUserData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { syncUser(); }, []);

  return (
    <UserContext.Provider value={{ userData, loading, refreshUser: syncUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);